/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateReportResponse
 */
export interface GenerateReportResponse {
    /**
     * 
     * @type {string}
     * @memberof GenerateReportResponse
     */
    report_s3_key: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateReportResponse
     */
    report_access_url: string;
}

/**
 * Check if a given object implements the GenerateReportResponse interface.
 */
export function instanceOfGenerateReportResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "report_s3_key" in value;
    isInstance = isInstance && "report_access_url" in value;

    return isInstance;
}

export function GenerateReportResponseFromJSON(json: any): GenerateReportResponse {
    return GenerateReportResponseFromJSONTyped(json, false);
}

export function GenerateReportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateReportResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'report_s3_key': json['report_s3_key'],
        'report_access_url': json['report_access_url'],
    };
}

export function GenerateReportResponseToJSON(value?: GenerateReportResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'report_s3_key': value.report_s3_key,
        'report_access_url': value.report_access_url,
    };
}

